import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { PreviewContext } from '../preview.types';
import { getExitPreviewData } from '../preview-style.resolver';
import { Questionnaire } from '@app/core/models/questionnaire.model';
import { QuestionSubType, QuestionType } from '@app/core/enums/questionnaire.enums';

@Component({
  selector: 'app-exit-screen-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './exit-screen-preview.html',
  styleUrl: './exit-screen-preview.scss',
})
export class ExitScreenPreviewComponent implements OnInit {
  @Input() context: PreviewContext | null = null;
  @Input() questionnaire: Questionnaire | null = null;
  @Input() viewMode: 'web' | 'mobile' = 'web';
  questionType = QuestionType;
  msgToDisplay: string = '';
  redirectionOption: boolean = false;
  url: string = '';
  reviewProvider: boolean = false;

  get data() {
    return getExitPreviewData(this.context);
  }
  ngOnInit(): void {
    if (this.questionnaire) {
      const question = this.questionnaire.questions.find((q) => q.questionType === QuestionType.SOCIAL_REVIEW);
      if (question) {
        this.reviewProvider = question.questionSpecificOptions.reviewProvider === 'GOOGLE' ? true : false;
        this.url = question.questionSpecificOptions.reviewUrl || '';
        this.redirectionOption = question.questionSpecificOptions.redirectionOption === 'MANUAL' ? true : false;
        if (this.redirectionOption) {
          const questionConditions = question.questionConditions.find((qc) => qc.parameter === 'RATING');
          if (questionConditions) {
            this.msgToDisplay = questionConditions.decisionTree.msgToDisplay || '';
          }
        }
      }
    }
  }
}
